const config = {
  apiUrl: 'https://api.cardio-scape.com',
};

export default config;